import { supabase } from '@/integrations/backend/client';

export type FunnelType = 'lead' | 'store' | 'chat';

/**
 * Fire-and-forget: records a single funnel step for a page visitor.
 * @param pageOwnerId  The UUID of the page owner (not the visitor).
 * @param funnelType   Which funnel this step belongs to.
 * @param step         Step name, e.g. 'lead_form_view', 'chat_open'.
 * @param metadata     Optional extra data to store with the event.
 */
export async function trackFunnelStep(
  pageOwnerId: string,
  funnelType: FunnelType,
  step: string,
  metadata?: Record<string, unknown>,
): Promise<void> {
  await supabase.from('funnel_events').insert({
    page_owner_id: pageOwnerId,
    funnel_type: funnelType,
    step,
    referrer: document.referrer || null,
    user_agent: navigator.userAgent || null,
    metadata: metadata ?? {},
  });
}
